module.exports = __webpack_public_path__ + "static/neumaticos-0c00d4c654c8191c30afc6b12cc5b2be.png";